<template>
  <div>
    <div class="dialog-body">
      <div>1.文件正在导出，请跳转至【导出记录】查看进度和下载文件</div>
      <div>2.关闭此弹窗不影响文件生成</div>
    </div>
    <div class="dialog-footer">
      <ElButton type="text" @click="handleCancel">取消</ElButton>
      <ElButton type="primary" @click="handleComfirm">查看进度</ElButton>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { resolveVueRouterAndOpenNewTab } from '@/services/utils/modules/routerWrapper'
export default {
  name: 'HcBizDownloadCenterGuidModal',
  data() {
    return {
      countDownSec: 10,
    }
  },
  methods: {
    handleComfirm() {
      this.$emit('comfirm')
      // resolveVueRouterAndOpenNewTab({
      //   name: 'bi-downloadCenter',
      // })
    },
    handleCancel() {
      this.$emit('cancel')
    },
  },
  mounted() {
    // this.intervalId = setInterval(() => {
    //   if (this.countDownSec < 1) {
    //     this.handleComfirm()
    //     clearInterval(this.intervalId)
    //     return
    //   }

    //   this.countDownSec -= 1
    // }, 1000)
  },
  beforeDestroy() {
    // clearInterval(this.intervalId)
  }
}
</script>
